import React from 'react';
import {connect} from 'react-redux';
import {toastr} from 'react-redux-toastr';
import {withStyles} from 'material-ui/styles';
import styles from './style/styles';
import UserPermissionsDisplayTable from './forms/UserPermissionsDisplayTable';
import ScrollToTop from '../../components/scroll-top/ScrollToTop';
import {
    fetchPermissionsGrouped,
    fetchUserPermissions
} from './thunks';

class UserPermissions extends React.Component {

    componentWillMount() {
        this.props.fetchPermissionsGrouped();
        this.props.fetchUserPermissions(this.props.userId);
    }

    componentWillUnmount() {
        toastr.removeByType('error');
    }

    render() {
        return (
            this.props.loading !== true && [
                <UserPermissionsDisplayTable
                    key={0}
                    userName={this.props.userName}
                    userId={this.props.userId}
                    groupedPermissions={this.props.groupedPermissions}
                    userPermissionsIds={this.props.userPermissionsIds}
                    classes={this.props.classes}
                />,
                <ScrollToTop key={1} />
            ]
        )
    }
};

const mapStateToProps = (state, props) => ({
    groupedPermissions: state.users.groupedPermissions,
    userPermissionsIds: state.users.userPermissions,
    loading: state.layout.ajaxCallsInProgress > 0,
});

export default connect(mapStateToProps, {
    fetchPermissionsGrouped,
    fetchUserPermissions
})(withStyles(styles)(UserPermissions));


// WEBPACK FOOTER //
// ./src/containers/users/UserPermissions.jsx